<template>
  <Activate :query="query"></Activate>
</template>

<script>
  import Activate from '@/views/onboarding/Activate.vue'

  export default{
    name: "Registration",
    components: {Activate},
    computed : {
      query() {
        return this.$route.query
      }
    },
    created () {
      if (this.query.token) {
        this.$store.dispatch('auth/saveToken', {token: this.query.token});
      }
    }
  }
</script>